import { List, ListItem } from "@mui/material";
import { GjennomkjoringForbudt } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import gjennomkjoringForbudtIconSource from "../../assets/GjennomkjoringForbudt.svg"

export default function GjennomkjoringForbudter(props: IRoutePartProps) {

    return (
        <>
            {props.roadFeatures && props.roadFeatures.gjennomkjoringForbudt && props.roadFeatures.gjennomkjoringForbudt.length > 0 &&
            <List>
                {props.roadFeatures.gjennomkjoringForbudt.map((gjennomkjoringForbudt: GjennomkjoringForbudt, index: number) => {
                    return <ListItem
                    key={gjennomkjoringForbudt.nvdbId + index}
                    className="roadFeature"
                    onClick={(event) => {props.onClick(gjennomkjoringForbudt, event)}}
                    onMouseEnter={() => {props.onMouseEnterItem(gjennomkjoringForbudt)}}
                    onMouseLeave={props.onMouseLeaveItem}>
                        <img src={gjennomkjoringForbudtIconSource} height="24" style={{paddingRight:"5px"}} alt="GjennomkjoringForbudt Icon" title="bomstasjonIcon"/> {gjennomkjoringForbudt.nvdbId}
                    </ListItem>
                })}
            </List>
            }
        </>
    )
}